import baseApi from "../../../common/api/baseApi";

const authHeaders = () => ({
  headers: { token: localStorage.getItem("token") }
});

export const updateUserApi = ({ oldPassword, password }) => {
  return baseApi
    .post("/member/updateUserPassword", {
        oldPassword : oldPassword,
        password : password
    }, authHeaders())
    .then(response => {
      return response.data;
    })
    .catch(error => {
      throw error;
    });
};

export const myInfoApi = () => {
  return baseApi
    .post("/member/myInfo", {}, authHeaders())
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};

export const updateAddressApi = ({ address }) => {
  return baseApi
    .post("/member/updateAddress", { address }, authHeaders())
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};
